"use strict";
var WebSocketSubject_1 = require('./WebSocketSubject');
exports.webSocket = WebSocketSubject_1.WebSocketSubject.create;
//# sourceMappingURL=webSocket.js.map


//////////////////
// WEBPACK FOOTER
// /root/anvel/~/rxjs/observable/dom/webSocket.js
// module id = ../../../../rxjs/observable/dom/webSocket.js
// module chunks = 4